module.exports = __webpack_public_path__ + "static/media/1009900.b2383b42.jpg";